export const formatPercentageChange = (value: number | null, multiplier = 1) => {
  if (value === null) return '-'

  const sign = value > 0 ? '+' : ''
  const percentage = (value * multiplier).toFixed(2)

  return `${sign}${percentage}%`
}
